import { render, staticRenderFns } from "./InvoiceReviseModal.vue?vue&type=template&id=22b0120b"
import script from "./InvoiceReviseModal.vue?vue&type=script&lang=js"
export * from "./InvoiceReviseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22b0120b')) {
      api.createRecord('22b0120b', component.options)
    } else {
      api.reload('22b0120b', component.options)
    }
    module.hot.accept("./InvoiceReviseModal.vue?vue&type=template&id=22b0120b", function () {
      api.rerender('22b0120b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/erp/components/InvoiceReviseModal.vue"
export default component.exports